<template>
  <div>
    <PageTitle :route="$route">
      <template slot="action-button">
        <ActionButton
          id="refresh"
          icon="fa-sync-alt"
        />
      </template>
    </PageTitle>

    <PageRowWrapper>
      <div class="col-sm-12">
        <ArenaVehicles2001 />
      </div>
    </PageRowWrapper>
  </div>
</template>

<script>
import PageTitle from '@/components/layout/PageTitle'
import PageRowWrapper from '@/components/layout/PageRowWrapper'
import ArenaVehicles2001 from '@/components/settings/parameters/arenavehicles2001/ArenaVehicles2001'
import ActionButton from '@/components/button/ActionButton'

export default {
  name: 'ArenaVehicles2001View',
  components: {
    PageTitle,
    PageRowWrapper,
    ArenaVehicles2001,
    ActionButton
  }
}
</script>